export enum RiskFormulaStatus {
  draft = 'DRAFT',
  active = 'ACTIVE'
}